<template>
  <div class="max-w-5xl mx-auto space-y-8">
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px" label-position="top">
      
      <!-- 成果归属 -->
      <AchievementTypeSection
        :achievement-type="formData.achievementType"
        :team-members="formData.teamMembers"
        @update:achievement-type="handleAchievementTypeChange"
        @update:team-members="handleTeamMembersChange"
      />
      
      
      <!-- 项目基本信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">项目基本信息</h3>
        <div class="space-y-4">
          <el-form-item label="项目名称" prop="project_name" required>
            <el-input
              v-model="formData.project_name"
              placeholder="请输入项目名称"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="项目编号" prop="project_num" required>
            <el-input
              v-model="formData.project_num"
              placeholder="请输入项目编号"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="项目来源" prop="project_source" required>
            <el-input
              v-model="formData.project_source"
              placeholder="请输入项目来源"
              class="custom-input"
            />
          </el-form-item>
        </div>
      </div>

      

      <!-- 项目类型与级别 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">项目类型与级别</h3>
        <div class="space-y-4">
          <el-form-item label="项目性质" prop="project_category_id" required>
            <el-select 
              v-model="formData.project_category_id" 
              placeholder="请选择项目性质"
              class="custom-select"
              popper-class="custom-select-dropdown"
            >
              <el-option value="1" label="纵向" />
              <el-option value="2" label="横向" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目级别" prop="project_level_id" required>
            <el-select 
              v-model="formData.project_level_id" 
              placeholder="请选择项目级别"
              class="custom-select"
              popper-class="custom-select-dropdown"
            >
              <el-option value="1" label="国家级" />
              <el-option value="2" label="省部级" />
              <el-option value="3" label="市级" />
              <el-option value="4" label="校级" />
              <el-option value="5" label="横向" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 项目详情 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">项目详情</h3>
        <div class="space-y-4">
          <el-form-item label="研究类型" prop="research_type" required>
            <el-select 
              v-model="formData.research_type" 
              placeholder="请选择研究类型"
              class="custom-select"
              popper-class="custom-select-dropdown"
            >
              <el-option value="基础研究" label="基础研究" />
              <el-option value="应用研究" label="应用研究" />
              <el-option value="试验发展" label="试验发展" />
            </el-select>
          </el-form-item>
          <el-form-item label="学科分类" prop="subject_classification" required>
            <el-input
              v-model="formData.subject_classification"
              placeholder="请输入学科分类"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="合作形式">
            <el-select 
              v-model="formData.cooperation_form" 
              placeholder="请选择合作形式"
              class="custom-select"
              popper-class="custom-select-dropdown"
            >
              <el-option value="独立承担" label="独立承担" />
              <el-option value="合作承担" label="合作承担" />
              <el-option value="分包承担" label="分包承担" />
            </el-select>
          </el-form-item>
          <el-form-item label="产学合作企业">
            <el-input
              v-model="formData.project_enterprise"
              placeholder="请输入产学合作企业"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="获奖情况">
            <el-input
              v-model="formData.project_award"
              placeholder="请输入获奖情况"
              class="custom-input"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 经费与时间 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">经费与时间</h3>
        <div class="space-y-4">
          <el-form-item label="总经费额度（元）" prop="project_fund" required>
            <el-input
              v-model="formData.project_fund"
              type="number"
              step="0.01"
              placeholder="请输入总经费额度"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="到校经费（元）" prop="project_fund_received" required>
            <el-input
              v-model="formData.project_fund_received"
              type="number"
              step="0.01"
              placeholder="请输入到校经费"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="立项时间" prop="project_approval_time" required>
            <el-date-picker
              v-model="formData.project_approval_time"
              type="date"
              placeholder="选择立项时间"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="结题时间" prop="project_finish_time" required>
            <el-date-picker
              v-model="formData.project_finish_time"
              type="date"
              placeholder="选择结题时间"
              style="width: 100%"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">其他信息</h3>
        <div class="space-y-4">
          <el-form-item label="备注">
            <el-input
              v-model="formData.remarks"
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
              class="custom-input"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 佐证材料 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">佐证材料</h3>
        <FileUpload 
          ref="uploadRef"
          title="佐证材料上传" 
          description="请上传相关的佐证材料" 
          @success="onUploadSuccess"
          @change="onUploadChange"
        />
      </div>

      <!-- 提交按钮 -->
      <div class="flex justify-end space-x-4 pt-6 border-t border-gray-200">
        <el-button 
          :disabled="loading"
          @click="submitForm(true)"
          class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none border bg-white text-gray-900 hover:bg-gray-50 hover:text-gray-900 h-9 px-4 py-2"
        >
          保存草稿
        </el-button>
        <el-button 
          :disabled="loading"
          @click="submitForm(false)"
          class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none bg-blue-600 text-white hover:bg-blue-700 h-9 px-4 py-2 border-0"
        >
          提交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import FileUpload from '../common/FileUpload.vue'
import AchievementTypeSection from '../common/AchievementTypeSection.vue'
import {
  saveScientificResearchProject,
  submitScientificResearchProject,
  updateScientificResearchProject,
  getScientificResearchProject
} from '../../api/scientificResearchProject'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
import { ensureValidTeamMembers } from '../../utils/teamMembers'
import { onMounted, nextTick } from 'vue'
import { getMyInfo } from '../../api/user'

const formData = reactive({
  achievementType: '',
  isFirstAuthor: '',
  isFirstInUnit: '',
  teamMembers: [],
  project_name: '',
  project_num: '',
  project_source: '',
  project_category_id: '',
  project_level_id: '',
  research_type: '',
  subject_classification: '',
  cooperation_form: '',
  project_enterprise: '',
  project_award: '',
  project_fund: '',
  project_fund_received: '',
  project_approval_time: '',
  project_finish_time: '',
  remarks: ''
})

const currentId = ref(null)
const loading = ref(false)
const formRef = ref(null)
const uploadRef = ref(null)
const rules = reactive({
  project_name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
  project_num: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
  project_source: [{ required: true, message: '请输入项目来源', trigger: 'blur' }],
  project_category_id: [{ required: true, message: '请选择项目性质', trigger: 'change' }],
  project_level_id: [{ required: true, message: '请选择项目级别', trigger: 'change' }],
  research_type: [{ required: true, message: '请选择研究类型', trigger: 'change' }],
  subject_classification: [
    { required: true, message: '请输入学科分类', trigger: 'blur' },
    { validator: subjectCategoryValidator, trigger: 'blur' }
  ],
  project_fund: [
    { required: true, message: '请输入总经费额度', trigger: 'blur' },
    { validator: nonNegativeNumberValidator, trigger: 'blur' }
  ],
  project_fund_received: [
    { required: true, message: '请输入到校经费', trigger: 'blur' },
    { validator: nonNegativeNumberValidator, trigger: 'blur' }
  ],
  project_approval_time: [{ required: true, message: '请选择立项时间', trigger: 'change' }],
  project_finish_time: [{ required: true, message: '请选择结题时间', trigger: 'change' }]
})
function subjectCategoryValidator(rule, value, callback) {
  const v = value == null ? '' : String(value).trim()
  if (!v) return callback()
  if (/^\d+$/.test(v)) return callback(new Error('请填写规范的学科分类中文名'))
  return callback()
}
function nonNegativeNumberValidator(rule, value, callback) {
  if (value === '' || value === null || value === undefined) return callback()
  const n = Number(value)
  if (!Number.isFinite(n) || n < 0) return callback(new Error('请输入有效的非负数字'))
  return callback()
}
// 证据材料（OSS 地址），内部维护列表并同步为逗号分隔字符串
const evidenceMaterial = ref('')
const evidenceMaterialList = ref([])
const myInfo = ref(null)
const LAST_DRAFT_KEY = 'researchProject:lastDraftId'
const DRAFT_FORM_KEY = 'researchProject:draftForm'
const DRAFT_STATUS_KEY = 'researchProject:draftStatus'

// 已移除：是否主持人选项（与设计版保持一致）

// 处理成果归属变化
const handleAchievementTypeChange = (value) => {
  formData.achievementType = value
}


const handleTeamMembersChange = (members) => {
  formData.teamMembers = members
}

// 上传事件处理
function onUploadSuccess({ url }) {
  if (url && !evidenceMaterialList.value.includes(url)) {
    evidenceMaterialList.value.push(url)
    evidenceMaterial.value = evidenceMaterialList.value.join(',')
  }
}

function onUploadChange({ url, type }) {
  if (type === 'remove' && url) {
    evidenceMaterialList.value = evidenceMaterialList.value.filter(u => u !== url)
    evidenceMaterial.value = evidenceMaterialList.value.join(',')
  }
}

// —— 工具方法 ——
function toNumber(v) {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

function toString(v) {
  return v == null ? '' : String(v)
}

const IDENTITY_LABELS = {
  teacher: '教师',
  student: '学生',
  social: '社会人士'
}
function toIdentityLabel(v) {
  const key = toString(v)
  return IDENTITY_LABELS[key] ?? key
}

// 项目性质 / 级别标签与代码映射（数码代码 -> 中文标签）
const PROJECT_TYPE_LABELS = {
  '1': '纵向',
  '2': '横向'
}

const PROJECT_LEVEL_LABELS = {
  '1': '国家级',
  '2': '省部级',
  '3': '市级',
  '4': '校级',
  '5': '横向'
}

function toProjectTypeLabel(v) {
  const key = toString(v)
  return PROJECT_TYPE_LABELS[key] ?? key
}

function toProjectLevelLabel(v) {
  const key = toString(v)
  return PROJECT_LEVEL_LABELS[key] ?? key
}

function fromProjectTypeLabel(label) {
  const val = toString(label)
  for (const [k, v] of Object.entries(PROJECT_TYPE_LABELS)) {
    if (v === val) return k
  }
  return val
}

function fromProjectLevelLabel(label) {
  const val = toString(label)
  for (const [k, v] of Object.entries(PROJECT_LEVEL_LABELS)) {
    if (v === val) return k
  }
  return val
}

function normalizeAchievementType(v) {
  // 后端期望整数：1=单人成果, 2=团队成果
  if (v === 'individual') return 1
  if (v === 'team') return 2
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

function denormalizeAchievementType(v) {
  if (v === 1 || v === '1') return 'individual'
  if (v === 2 || v === '2') return 'team'
  return ''
}

function normalizeMembers(list) {
  // 转换为后端 MemberDTO: { position, name, unit }
  return Array.isArray(list)
    ? list.map((m, i) => ({
        position: toNumber(m?.rank ?? i + 1),
        name: toString(m?.name),
        identity: toIdentityLabel(m?.identity),
        unit: toString(m?.unit)
      }))
    : []
}

function formatDateTimePlain(input) {
  if (!input) return null
  try {
    const d = typeof input === 'string' ? new Date(input) : input
    if (!(d instanceof Date) || isNaN(d.getTime())) return null
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`)
    const y = d.getFullYear()
    const m = pad(d.getMonth() + 1)
    const day = pad(d.getDate())
    const h = pad(d.getHours())
    const min = pad(d.getMinutes())
    const s = pad(d.getSeconds())
    return `${y}-${m}-${day} ${h}:${min}:${s}`
  } catch {
    return null
  }
}

function sanitizeEvidenceMaterial(s) {
  const v = String(s || '')
  if (!v) return ''
  return v
    .split(',')
    .map(p => String(p || '').trim().replace(/`/g, ''))
    .filter(Boolean)
    .join(',')
}
function isValidUrl(u) {
  const s = String(u || '')
  return /^https?:\/\/\S+$/i.test(s)
}
function filterValidEvidence(s) {
  const sanitized = sanitizeEvidenceMaterial(s)
  if (!sanitized) return ''
  const parts = sanitized.split(',').map(p => p.trim()).filter(isValidUrl)
  return parts.length ? parts.join(',') : ''
}

// —— 映射函数（提交） ——
function mapFormToApi(data) {
  const dto = {
    id: currentId.value || undefined,
    achievementType: normalizeAchievementType(data.achievementType),
    memberList: normalizeMembers(data.teamMembers),
    projectName: data.project_name,
    projectNumber: data.project_num,
    projectSource: data.project_source,
    projectNature: toProjectTypeLabel(data.project_category_id),
    projectLevel: toProjectLevelLabel(data.project_level_id),
    researchType: data.research_type,
    subjectCategory: data.subject_classification,
    cooperationForm: data.cooperation_form,
    cooperationEnterprise: data.project_enterprise,
    awardSituation: data.project_award,
    totalFunding: toNumber(data.project_fund),
    schoolFunding: toNumber(data.project_fund_received),
    approvalTime: formatDateTimePlain(data.project_approval_time),
    conclusionTime: formatDateTimePlain(data.project_finish_time),
    remark: data.remarks,
    evidenceMaterial: filterValidEvidence(evidenceMaterial.value || '')
  }
  if (dto.achievementType === 1 && (!Array.isArray(dto.memberList) || dto.memberList.length === 0)) {
    const info = myInfo.value || {}
    const name = toString(info?.name)
    const identity = toString(info?.role || '教师')
    const unit = toString(info?.college || '')
    dto.memberList = name || unit ? [{ position: 1, name, identity, unit }] : []
  }
  return dto
}

// —— 映射函数（回显） ——
function mapApiToForm(dto = {}) {
  formData.achievementType = denormalizeAchievementType(dto.achievementType)
  formData.teamMembers = Array.isArray(dto.memberList)
    ? dto.memberList.map((m, i) => ({
        id: `${Date.now()}_${i}`,
        name: toString(m?.name),
        identity: toString(m?.identity),
        unit: toString(m?.unit),
        rank: toNumber(m?.position ?? i + 1)
      }))
    : []
  
  formData.project_name = dto.projectName ?? ''
  formData.project_num = dto.projectNumber ?? ''
  formData.project_source = dto.projectSource ?? ''
  
  formData.project_category_id = fromProjectTypeLabel(dto.projectNature)
  formData.project_level_id = fromProjectLevelLabel(dto.projectLevel)

  formData.research_type = dto.researchType ?? ''
  formData.subject_classification = dto.subjectCategory ?? ''
  formData.cooperation_form = dto.cooperationForm ?? ''
  formData.project_enterprise = dto.cooperationEnterprise ?? ''
  formData.project_award = dto.awardSituation ?? ''

  formData.project_fund = toString(dto.totalFunding)
  formData.project_fund_received = toString(dto.schoolFunding)
  formData.project_approval_time = dto.approvalTime ? new Date(dto.approvalTime) : ''
  formData.project_finish_time = dto.conclusionTime ? new Date(dto.conclusionTime) : ''

  formData.remarks = dto.remark ?? ''

  const em = dto.evidenceMaterial || ''
  evidenceMaterial.value = em
  evidenceMaterialList.value = em ? String(em).split(',').filter(Boolean) : []
}
// 提交表单
const submitForm = async (isDraft = false) => {
  try {
    loading.value = true
    const ok = await (formRef.value?.validate?.() ?? Promise.resolve(true)).catch(() => false)
    if (!ok) {
      ElMessage.error('请完善所有必填项')
      loading.value = false
      return
    }
    if (!formData.achievementType) {
      ElMessage.error('请选择成果归属')
      loading.value = false
      return
    }
    if (formData.achievementType === 'team') {
      const { ok: membersOk, message } = ensureValidTeamMembers(formData.achievementType, formData.teamMembers)
      if (!membersOk) {
        ElMessage.error(message || '团队成员信息未填写完整')
        loading.value = false
        return
      }
    }
    const at = formData.project_approval_time ? new Date(formData.project_approval_time).getTime() : NaN
    const ct = formData.project_finish_time ? new Date(formData.project_finish_time).getTime() : NaN
    if (Number.isFinite(at) && Number.isFinite(ct) && ct < at) {
      ElMessage.error('结题时间不能早于立项时间')
      loading.value = false
      return
    }
    
    const basePayload = { ...mapFormToApi(formData) }
    console.log('[ResearchProject] base payload', basePayload)
    if (isDraft) {
      const em = sanitizeEvidenceMaterial(evidenceMaterial.value || '')
      const validEm = em && em.split(',').every(u => /^https?:\/\/\S+$/.test(u))
      const draftPayload = { ...basePayload, id: currentId.value || undefined }
      if (!validEm) delete draftPayload.evidenceMaterial
      if (currentId.value) {
        await updateScientificResearchProject({ ...draftPayload, id: currentId.value, status: 1 })
      } else {
        const resp = await saveScientificResearchProject({ ...draftPayload, status: 1 })
        const id = resp?.id ?? resp?.data?.id
        if (id) currentId.value = id
      }
      if (!currentId.value) {
        try {
          localStorage.setItem(LAST_DRAFT_KEY, String(currentId.value))
          localStorage.setItem(DRAFT_STATUS_KEY, '1')
          const snapshot = {
            form: { ...formData },
            evidenceMaterial: evidenceMaterial.value || '',
            evidenceMaterialList: Array.isArray(evidenceMaterialList.value) ? [...evidenceMaterialList.value] : [],
            currentId: currentId.value || null
          }
          localStorage.setItem(DRAFT_FORM_KEY, JSON.stringify(snapshot))
        } catch (e) { console.warn(e) }
      }
      ElMessage.success('草稿保存成功')
    } else {
      if (!currentId.value) {
        const submitBase = { ...mapFormToApi(formData) }
        const em = sanitizeEvidenceMaterial(evidenceMaterial.value || '')
        const validEm = em && em.split(',').every(u => /^https?:\/\/\S+$/.test(u))
        if (!validEm) delete submitBase.evidenceMaterial
        const submitPayload = { ...submitBase, status: 2 }
        await submitScientificResearchProject(submitPayload)
      } else {
        const em = sanitizeEvidenceMaterial(evidenceMaterial.value || '')
        const validEm = em && em.split(',').every(u => /^https?:\/\/\S+$/.test(u))
        const updPayload = { ...basePayload, id: currentId.value }
        if (!validEm) delete updPayload.evidenceMaterial
        await updateScientificResearchProject({ ...updPayload, id: currentId.value, status: 2 })
      }
      ElMessage.success('提交成功')
      resetForm()
      try { await nextTick(); formRef.value?.clearValidate?.(); formRef.value?.resetFields?.() } catch (e) { console.warn(e) }
      try { localStorage.removeItem(LAST_DRAFT_KEY) } catch (e) { console.warn(e) }
      try { localStorage.removeItem(DRAFT_FORM_KEY) } catch (e) { console.warn(e) }
      try { localStorage.removeItem(DRAFT_STATUS_KEY) } catch (e) { console.warn(e) }
    }
  } catch (err) {
    console.error(err)
    ElMessage.error(isDraft ? '草稿保存失败' : '提交失败')
  } finally {
    loading.value = false
  }
}

// 重置表单
const resetForm = () => {
  Object.assign(formData, {
    achievementType: '',
    isFirstAuthor: '',
    isFirstInUnit: '',
    teamMembers: [],
    project_name: '',
    project_num: '',
    project_source: '',
    project_category_id: '',
    project_level_id: '',
    research_type: '',
    subject_classification: '',
    cooperation_form: '',
    project_enterprise: '',
    project_award: '',
    project_fund: '',
    project_fund_received: '',
    project_approval_time: '',
    project_finish_time: '',
    remarks: ''
  })
  evidenceMaterial.value = ''
  evidenceMaterialList.value = []
  currentId.value = null
  try { uploadRef.value?.clear?.() } catch { void 0 }
}

// —— 通过路由回显加载 ——
const route = useRoute()
onMounted(async () => {
  const rid = route.query?.detailId || route.query?.id  // ← 优先用 detailId
  try {
    const info = await getMyInfo()
    const data = info?.data ?? info
    myInfo.value = data
  } catch {
    void 0
  }
  if (rid) {
    try {
      currentId.value = rid
      const dto = await getScientificResearchProject(rid)
      // 支持 data 包裹
      mapApiToForm(dto?.data ?? dto)
    } catch (e) {
      console.warn('加载研究项目详情失败', e)
    }
  } else {
    try {
      const draftFlag = localStorage.getItem(DRAFT_STATUS_KEY)
      if (draftFlag === '1') {
        const raw = localStorage.getItem(DRAFT_FORM_KEY)
        if (raw) {
          try {
            const snapshot = JSON.parse(raw)
            const f = snapshot?.form || {}
            Object.assign(formData, f)
            evidenceMaterial.value = snapshot?.evidenceMaterial || ''
            evidenceMaterialList.value = Array.isArray(snapshot?.evidenceMaterialList) ? [...snapshot.evidenceMaterialList] : []
            const id = snapshot?.currentId || localStorage.getItem(LAST_DRAFT_KEY)
            if (id) currentId.value = id
          } catch (e) { console.warn(e) }
        }
      }
    } catch (e) { console.warn(e) }
  }
})


</script>

<style scoped>
.form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 自定义Select样式，匹配React版本 */
:deep(.custom-select .el-select__wrapper) {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

:deep(.custom-select .el-select__wrapper:hover) {
  border-color: #9ca3af;
}

:deep(.custom-select .el-select__wrapper.is-focused) {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

:deep(.custom-select .el-select__placeholder) {
  color: #9ca3af;
}

:deep(.custom-select .el-select__input) {
  color: #111827;
}

/* 自定义Input样式，与Select保持一致，添加灰度加深效果 */
:deep(.custom-input .el-input__wrapper) {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

:deep(.custom-input .el-input__wrapper:hover) {
  border-color: #9ca3af;
  background-color: #f3f4f6;
}

:deep(.custom-input .el-input__wrapper.is-focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  background-color: white;
}

:deep(.custom-input .el-input__inner) {
  color: #111827;
  background-color: transparent;
}

:deep(.custom-input .el-input__inner::placeholder) {
  color: #9ca3af;
}

/* 下拉框样式 */
:deep(.custom-select-dropdown) {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  background-color: white;
}

:deep(.custom-select-dropdown .el-select-dropdown__item) {
  padding: 8px 12px;
  color: #374151;
  transition: all 0.2s ease-in-out;
}

:deep(.custom-select-dropdown .el-select-dropdown__item:hover) {
  background-color: #f3f4f6;
  color: #111827;
}

:deep(.custom-select-dropdown .el-select-dropdown__item.is-selected) {
  background-color: #dbeafe;
  color: #1d4ed8;
  font-weight: 500;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .max-w-5xl {
    max-width: 100%;
    padding: 0 1rem;
  }
}
</style>
